angular.module('aprima-patient-api').factory('PatientSettingsRepository',
    ['AprimaRestangular', 'storage',
        function (AprimaRestangular, storage) {
            'use strict';

            var patientFeatures = function (userid) {
                return AprimaRestangular.get('patient').one('settings/usersettings/' + userid).get();
            };
            var setFeatureList = function (value){
                return storage.set('featureList', value);
            };
            var getFeatureList = function () {
                return storage.get('featureList');
            };

            return {
                patientFeatures: patientFeatures,
                setFeatureList: setFeatureList,
                getFeatureList: getFeatureList
            };

        }]);